import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const BarChart = (props) => {
  const setTheColorOfAqi = (x) => {
    if (x <= 50) {
      return "#0f9d63";
    } else if (x > 50 && x <= 100) {
      return "#ffd700";
    } else if (x > 100 && x <= 150) {
      return "#ff8c00";
    } else if (x > 150 && x <= 200) {
      return "#ff0000";
    } else if (x > 200 && x <= 300) {
      return "#800080";
    } else if (x > 300) {
      return "#a52a2a";
    } else {
      return "#8f8f8f";
    }
  };

  let labels = [];
  if (props.type === "gasAndParticles") {
    labels = ["AQI", "CO", "O3", "NO2", "SO2", "PM2.5", "PM10"];
  } else if (props.type === "onlyParticles") {
    labels = ["AQI", "PM2.5", "PM10"];
  }

  let chartData = [];
  if (props.type === "gasAndParticles") {
    chartData = [
      props.data.AQI,
      props.data.COAQI,
      props.data.O3AQI,
      props.data.NO2AQI,
      props.data.SO2AQI,
      props.data.PM25AQI,
      props.data.PM10AQI,
    ];
  } else if (props.type === "onlyParticles") {
    chartData = [props.data.AQI, props.data.PM25AQI, props.data.PM10AQI];
  }

  let titleText = "";
  if (props.typeBasedOfTime === "online") {
    titleText = "شاخص کیفیت هوا - برخط";
  } else if (props.typeBasedOfTime === "hourly") {
    titleText = "شاخص کیفیت هوا - ساعتی ";
  } else if (props.typeBasedOfTime === "daily") {
    titleText = "شاخص کیفیت هوا - روزانه";
  } else if (props.typeBasedOfTime === "twelve") {
    titleText = "شاخص کیفیت هوا - هم اکنون";
  } else if (props.typeBasedOfTime === "twentyFour") {
    titleText = "شاخص کیفیت هوا - آنلاین";
  }

  let chartColors = [];
  if (props.type === "gasAndParticles") {
    chartColors = [
      setTheColorOfAqi(props.data.AQI),
      setTheColorOfAqi(props.data.COAQI),
      setTheColorOfAqi(props.data.O3AQI),
      setTheColorOfAqi(props.data.NO2AQI),
      setTheColorOfAqi(props.data.SO2AQI),
      setTheColorOfAqi(props.data.PM25AQI),
      setTheColorOfAqi(props.data.PM10AQI),
    ];
  } else if (props.type === "onlyParticles") {
    chartColors = [
      setTheColorOfAqi(props.data.AQI),
      setTheColorOfAqi(props.data.PM25AQI),
      setTheColorOfAqi(props.data.PM10AQI),
    ];
  }

  const data = {
    labels,
    datasets: [
      {
        label: "آمار امروز",

        data: chartData,
        backgroundColor: chartColors,
      },
    ],
  };

  return (
    <Bar
      className="chart-white bg-white mx-auto p-3 my-5"
      style={{ width: "90%" }}
      data={data}
      options={{
        lineAt: 100,
        maxBarThickness: 45,
        minBarLength: 10,
        responsive: true,
        plugins: {
          title: {
            display: true,
            text: titleText,
            padding: 10,
          },
          legend: {
            display: false,
          },
          datalabels: {
            display: false,
          },
        },
      }}
    ></Bar>
  );
};

export default BarChart;
